import React, { PropsWithChildren, ElementType, MouseEvent } from "react";
import cx from "classnames";

export interface NavItemProps {
  to?: string;
  icon?: ElementType;
  className?: string;
  isSubNav?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  "data-testid"?: string;
}

const NavItem = ({
  to,
  icon: Icon,
  isSubNav,
  className,
  onClick,
  children,
  "data-testid": dataTestId,
}: PropsWithChildren<NavItemProps>) => {
  const navClassName = cx(
    "flex gap-2.5 items-center px-5 py-3 h-[50px] w-full text-s text-color-neutral-one",
    "hover:bg-grey-fog-1 focus:underline focus:bg-grey-fog-1 focus:outline-none",
    { "font-normal pl-[65px]": isSubNav, "font-semibold": !isSubNav },
    className
  );

  if (to) {
    return (
      <a
        className={navClassName}
        href={to}
        onClick={onClick}
        data-testid={dataTestId}
      >
        {Icon && <Icon width={25} height={25} />}
        {children}
      </a>
    );
  }

  if (onClick)
    return (
      <button
        className={navClassName}
        onClick={onClick}
        data-testid={dataTestId}
      >
        {Icon && <Icon width={25} height={25} />}
        {children}
      </button>
    );

  return null;
};

export default NavItem;
